import { ArkThemeProvider } from "@ark/ui/primitives";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { GlobalErrorBridge } from "./GlobalErrorBridge";
import { GlobalStyles } from "./GlobalStyles";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failures, error) =>
        failures < 2 && !(error instanceof Error && error.name === "ApiError"),
      staleTime: 30_000,
    },
  },
});

const root = document.getElementById("root");
if (!root) throw new Error("missing #root");

createRoot(root).render(
  <StrictMode>
    <ArkThemeProvider>
      <GlobalErrorBridge />
      <GlobalStyles />
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ArkThemeProvider>
  </StrictMode>,
);
